import { Toast } from "../types";

interface ToastStackProps {
  toasts: Toast[];
}

export const ToastStack = ({ toasts }: ToastStackProps) => (
  <div className="toast-stack" aria-live="polite" aria-atomic="true">
    {toasts.map((toast) => (
      <div className={`toast ${toast.tone ?? "info"}`} key={toast.id}>
        {toast.message}
      </div>
    ))}
  </div>
);
